import React from 'react';
import SiteLayout from '../components/SiteLayout';
import Reveal from '../components/Reveal';
import HomeHero from '../home/HomeHero';
import AboutSection from '../home/AboutSection';
import ServicesSection from '../home/ServicesSection';
import ClientsSection from '../home/ClientsSection';
import ContactSection from '../home/ContactSection';
import useHashScroll from '../components/useHashScroll';
import '../home/home.css';

// §7.1 — Hero slider → About → Services → Contact.
export default function HomePage() {
  useHashScroll();
  return (
    <SiteLayout navVariant="main">
      <HomeHero />
      <Reveal>
        <AboutSection />
      </Reveal>
      <ServicesSection />
      <ClientsSection />
      <Reveal>
        <ContactSection />
      </Reveal>
    </SiteLayout>
  );
}
